export class AnalyticEdit
{
    public id = null;
    public version = null;
    public name = '';
    public description = '';
    public link = '';
    public enabled = true;
    public organizations: any = [];
    public allOrganizations = false;
}
